import { useCreateClientComment } from "./useCreateClientComment";
import { useUpdateClientComment } from "./useUpdateClientComment";

export function usePublishing(
  createNewComment,
  comment,
  clientId,
  draftGid,
  taskUuid,
  clientWorkflowUuid
) {
  const { createComment } = useCreateClientComment(
    clientId,
    draftGid,
    taskUuid,
    clientWorkflowUuid
  );

  const { updateComment } = useUpdateClientComment(comment?.id);

  return async (preparedContent) => {
    return (
      createNewComment
        ? createComment(preparedContent)
        : updateComment(preparedContent)
    ).then((response) => {
      if (response?.errors) {
        console.warn("Errors during publishing", response.errors);
        throw new Error("Error during publishing");
      }
      return response;
    });
  };
}

export default usePublishing;
